module.exports = __webpack_public_path__ + "static/media/covid19-qr-top-banner.5ad0f7f7.png";